import BasicInitializationService from "services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import MultiEshopViewModel from "../../viewModels/multiEshop/multiEshopViewModel";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";

const MultiEshopWidgetIdentifier = "edaz-multi-eshop";

registerWidget({
  component: makeWidgetFor(MultiEshopWidgetIdentifier, [MultiEshopViewModel], InitializationWithOutagesService),
  configuration: {
    tagname: MultiEshopWidgetIdentifier,
  },
});
